import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { Spiner } from "../../components/spinner/Spiner";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";

export type MovieContentsSelectModalProp = {
  contentsColumns: GridCol[];
  contentsRowList: GridRow[];
  onContentsSelect: () => void;
  isLoad: boolean;
}

export const MovieContentsSelectModal = ({
  open,
  toggle,
  closeOnClickOutside,
  contentsColumns,
  contentsRowList,
  onContentsSelect,
  isLoad,
}: ModalProp & MovieContentsSelectModalProp) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xltransition-all sm:w-full max-w-screen-2xl ">
          <div className="text-center sm:mt-3">
            <Dialog.Title
              as="h3"
              className="text-left p-4 text-lg font-medium leading-6 text-gray-900"
            >
              動画コンテンツ選択
            </Dialog.Title>
            <div className="overflow-y-auto">
              <div className="text-left h-[calc(100vh_-_16rem)] px-4 pb-4">
                {isLoad ? (<Spiner/>) : (
                  <TableList
                    gridCol={contentsColumns}
                    gridRow={contentsRowList}
                    header
                  />
                )}
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              children={'登録'}
              onClick={onContentsSelect}
              disabled={isLoad}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}